<!-- Non-dismissible backdrop: pointer-events: none prevents clicks from closing the modal -->
<div class="picker-backdrop"></div>

<div class="picker-dialog" role="dialog" aria-modal="true" aria-labelledby="picker-title">
  <div class="picker-header">
    <h2 id="picker-title">Select Your Active Context</h2>
  </div>

  <div class="picker-body">
    <p class="picker-description">
      Please select
      <ng-container *ngIf="mode === 'super-admin'">a group and </ng-container>an organization
      to continue.
    </p>

    <div class="picker-field" *ngIf="mode === 'super-admin'">
      <label for="picker-group-select" class="picker-label">Group</label>
      <select
        id="picker-group-select"
        class="picker-select"
        [value]="selectedGroupId ?? ''"
        (change)="onGroupChange($event)"
        aria-label="Select group"
      >
        <option value="" disabled>Select a group...</option>
        <option *ngFor="let group of sortedGroups" [value]="group.GROUP_ID">
          {{ group.GROUP_NAME }}
        </option>
      </select>
    </div>

    <div class="picker-field">
      <label for="picker-org-select" class="picker-label">Organization</label>
      <select
        id="picker-org-select"
        class="picker-select"
        [value]="selectedOrgId ?? ''"
        (change)="onOrgChange($event)"
        [disabled]="mode === 'super-admin' && selectedGroupId === null"
        aria-label="Select organization"
      >
        <option value="" disabled>
          <ng-container *ngIf="mode === 'super-admin' && selectedGroupId === null">
            Select a group first...
          </ng-container>
          <ng-container *ngIf="mode !== 'super-admin' || selectedGroupId !== null">
            Select an organization...
          </ng-container>
        </option>
        <option *ngFor="let org of sortedOrgs" [value]="org.ORGANIZATION_ID">
          {{ org.ORGANIZATION_NAME }}
        </option>
      </select>
    </div>
  </div>

  <div class="picker-footer">
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="!canConfirm"
      (click)="onConfirm()"
    >
      Continue
    </button>
  </div>
</div>
